var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "node dag-node", class: { 'is-visible': _vm.visible } });
};
var staticRenderFns = [];

export { render, staticRenderFns };